import { combineReducers } from "redux";

export const types = {
  SET_USER_INFO: "USER_LOGIN/SET_USER_INFO",
  SET_SHOW_LOGIN: "USER_LOGIN/SET_SHOW_LOGIN",
  SET_USER_STATE: "USER_LOGIN/SET_USER_STATE",
  SET_USER_LINK: "USER_LOGIN/SET_USER_LINK",
  SET_USER_DAY_UP_LINK: "USER_LOGIN/SET_USER_DAY_UP_LINK",
};

const initialState = {
  userInfo: {
    phone: "",
    year: "",
    isActive: false,
    isLogin: false,
    isBuy: false,
    discounts: 0,
    isWhiteUser: false,
  },
  uiState: {
    showLogin: false,
    userState: "我的",
    userLink: "/my",
    dayUpLink: "/pay",
  },
};

export const actions = {
  //设置用户登录信息
  setUserInfo: (userInfo) => {
    return {
      type: types.SET_USER_INFO,
      userInfo,
    };
  },
  //设置登录框的显示状态
  setShowLogin: (showLogin) => {
    return {
      type: types.SET_SHOW_LOGIN,
      showLogin,
    };
  },
  //设置网站底部切换tab我的的登录状态
  setUserState: (userState) => {
    return {
      type: types.SET_USER_STATE,
      userState,
    };
  },
  //设置网站底部切换tab我的的路由链接
  setUserLink: (userLink) => {
    return {
      type: types.SET_USER_LINK,
      userLink,
    };
  },
  //设置网站底部切换tab每日高升的路由链接
  setUserDayUpLink: (dayUpLink) => {
    return {
      type: types.SET_USER_DAY_UP_LINK,
      dayUpLink,
    };
  },
};

//用户数据
const userData = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_USER_INFO:
      return { ...state, userInfo: action.userInfo };
    default:
      return { ...state };
  }
};

//登录框的ui样式数据
const uiStateData = (state = initialState.uiState, action) => {
  switch (action.type) {
    case types.SET_SHOW_LOGIN:
      return { ...state, showLogin: action.showLogin };
    case types.SET_USER_STATE:
      return { ...state, userState: action.userState };
    case types.SET_USER_LINK:
      return { ...state, userLink: action.userLink };
    case types.SET_USER_DAY_UP_LINK:
      return { ...state, dayUpLink: action.dayUpLink };
    default:
      return { ...state };
  }
};

const reducer = combineReducers({
  userData,
  uiStateData,
});

export default reducer;



// WEBPACK FOOTER //
// ./src/redux/modules/user.js